const destinations = [
  { name: "Mexico & Caribbean", context: "Family vacations booked via MSY promotions, JNOLA cruise departures to Cozumel, Cancun, and Nassau", urgency: "Last-minute promotional bookings create 2–4 week passport windows", icon: "ri-map-pin-2-line" },
  { name: "United Kingdom", context: "Airline employees on international deadhead assignments, Kenner business executives at London client meetings", urgency: "International airline deadhead assignments can arrive with 24–72 hours notice", icon: "ri-map-pin-2-line" },
  { name: "West Africa — Nigeria & Angola", context: "Petrochemical workers and offshore energy contractors rotating to deepwater platforms from Kenner-area staging areas", urgency: "International rotation papers often arrive with 10–21 days notice", icon: "ri-map-pin-2-line" },
  { name: "France & Italy", context: "Heritage travel for Kenner's Cajun-French community, culinary tourism, and European leisure trips departing MSY", urgency: "Heritage travel often planned quickly around family milestones and reunions", icon: "ri-map-pin-2-line" },
  { name: "Canada", context: "Business travel to Calgary energy sector offices, Niagara Falls family trips, and Toronto connections", urgency: "Energy industry meetings in Calgary often involve compressed scheduling", icon: "ri-map-pin-2-line" },
  { name: "Germany & Netherlands", context: "Maritime industry professionals from the Avondale shipyard corridor attending technical conferences in Hamburg and Rotterdam", urgency: "Industry conference registration and travel are often compressed to 3–6 weeks", icon: "ri-map-pin-2-line" },
];

const stats = [
  { stat: "2 Miles", label: "from downtown Kenner to MSY — closest community to a major international airport in Louisiana" },
  { stat: "24–72 Hrs", label: "typical notice for MSY airline worker international deadhead or transfer assignments" },
  { stat: "Mar–Aug", label: "peak season for Jefferson Parish family cruise bookings and Caribbean vacation passport urgencies" },
  { stat: "60%", label: "of Kenner expedited passport cases involve travel departing within 14 days of the passport request" },
];

export default function KennerDestinationsSection() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Local Travel Intelligence</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Where Kenner Travelers Go — And Why Passports Get Urgent
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            These are the destinations and travel patterns we see most from Kenner and Jefferson Parish clients. Our document review team is trained on exactly these scenarios — so nothing gets missed before your MSY departure.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-14">
          {stats.map((s, i) => (
            <div key={i} className="bg-[#1A365D] rounded-lg p-6 text-center">
              <p className="font-serif text-3xl font-bold text-[#F6C344] mb-2">{s.stat}</p>
              <p className="text-white/60 text-xs leading-relaxed">{s.label}</p>
            </div>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-12">
          {destinations.map((d, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200 hover:border-[#F6C344] transition-all group">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#1A365D]/5 group-hover:bg-[#F6C344]/15 transition-colors flex-shrink-0">
                  <i className={`${d.icon} text-[#1A365D] group-hover:text-[#F6C344] transition-colors text-lg`}></i>
                </div>
                <h3 className="font-bold text-[#1A365D] text-sm">{d.name}</h3>
              </div>
              <p className="text-gray-500 text-sm leading-relaxed mb-3">{d.context}</p>
              <div className="flex items-start gap-2">
                <i className="ri-time-line text-[#F6C344] text-xs flex-shrink-0 mt-0.5"></i>
                <p className="text-gray-400 text-xs leading-relaxed italic">{d.urgency}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-200">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
            <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#1A365D]/5 flex-shrink-0">
              <i className="ri-links-line text-[#1A365D] text-xl"></i>
            </div>
            <div className="flex-1">
              <h3 className="font-bold text-[#1A365D] text-sm mb-1">Explore Other Louisiana Service Areas</h3>
              <p className="text-gray-500 text-sm leading-relaxed">
                We serve travelers across Louisiana with the same professional expedited passport processing. Looking for service in another community?
              </p>
            </div>
            <div className="flex flex-wrap gap-2 flex-shrink-0">
              {[
                { name: "New Orleans", href: "/cities/new-orleans" },
                { name: "Metairie", href: "/cities/metairie" },
                { name: "Slidell", href: "/cities/slidell" },
              ].map((link) => (
                <a key={link.href} href={link.href} className="inline-flex items-center gap-1.5 bg-white hover:bg-[#1A365D] text-[#1A365D] hover:text-white border border-gray-200 hover:border-[#1A365D] font-medium text-xs px-3.5 py-2 rounded-md transition-all whitespace-nowrap">
                  {link.name} <i className="ri-arrow-right-line text-xs"></i>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}